import { render } from "./PersonalAccount.vue?vue&type=template&id=0f55cac2&scoped=true"
import script from "./PersonalAccount.vue?vue&type=script&lang=js"
export * from "./PersonalAccount.vue?vue&type=script&lang=js"

import "./PersonalAccount.vue?vue&type=style&index=0&id=0f55cac2&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f55cac2"]])

export default __exports__